module.exports = __webpack_public_path__ + "img/s4.6c38ac44.png";